import React, { Component } from "react";

import {
  StyleSheet,
  TouchableOpacity,
  Content,
  View,
  Image,
  Navigator,
  Text,
  TextInput
} from "react-1app";

import Menu from "./Menu.js";

export default class Criarlogin extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    Navigator.cloneState(this);
  }

  criar() {}
  // this.state.user_local = new Model("user_local");
  // this.state.user_local.nome = this.state.nome;
  // this.state.user_local.login = this.state.login;
  // this.state.user_local.senha = this.state.senha;
  // this.setState({ save: true });
  // this.state.user_local.setMetodoApi("salvar", "POST");
  // console.log(this.state.user_local);
  // this.state.user_local.save(() => {
  //   this.setState({ save: false });
  //   this.state.navigator.closeModal();
  //   this.state.dispatch({
  //     type: "user_local",
  //     user_local: this.state.user_local
  //   });
  // });

  componentDidMount() {
    this.unsubscribe = this.props.screenProps.store.subscribe(() => {
      this.setState(this.props.screenProps.store.getState());
    });
  }

  componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe();
  }

  render() {
    return (
      <Content style={styles.content}>
        <View style={styles.view2}>
          <Image
            style={styles.image1}
            source={"/img/logo-header.png"}
            resizeMode={"contain"}
          />
          <View style={styles.view1}>
            <Text style={styles.text2} text={"Criar cadastro:"} />
            <TextInput
              style={styles.textinput4}
              value={this.state.nome}
              onChange={value => {
                this.state.nome = value;
                this.setState({ item: this.state.item });
              }}
              keyboardType={"default"}
              label={"Nome"}
              ref={v => (this.textinput = v)}
            />
            <TextInput
              style={styles.textinput11}
              value={this.state.login}
              onChange={value => {
                this.state.login = value;
                this.setState({ item: this.state.item });
              }}
              keyboardType={"default"}
              label={"Login"}
              ref={v => (this.textinput1 = v)}
            />
            <TextInput
              style={styles.textinput21}
              value={this.state.senha}
              onChange={value => {
                this.state.senha = value;
                this.setState({ item: this.state.item });
              }}
              keyboardType={"default"}
              label={"Senha"}
              ref={v => (this.textinput2 = v)}
            />
            <TextInput
              style={styles.textinput31}
              value={this.state.confirmacao}
              onChange={value => {
                this.state.confirmacao = value;
                this.setState({ item: this.state.item });
              }}
              keyboardType={"default"}
              label={"Confirmar Senha"}
              ref={v => (this.textinput3 = v)}
            />
            <TouchableOpacity
              style={styles.button1}
              onPress={() => {
                this.criar();
              }}
            >
              <Text style={styles.text11} text={"Salvar"} />
            </TouchableOpacity>
          </View>
        </View>
      </Content>
    );
  }
}

var styles = StyleSheet.create({
  content: {
    backgroundColor: "rgba(255,255,255,1)",
    alignSelf: "center",
    flex: 1,
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "row"
  },
  view2: {
    alignSelf: "stretch",
    flex: 1,
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    backgroundColor: "rgba(255,255,255,0)",
    paddingTop: 10
  },
  image1: {
    width: 300,
    height: 100,
    alignSelf: "center",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    borderRadius: 15
  },
  view1: {
    alignSelf: "center",
    flex: 1,
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    width: 300,
    paddingBottom: 10
  },
  text2: {
    textAlign: "center",
    color: "rgba(123,123,123,1)",
    alignSelf: "stretch",
    fontWeight: "normal",
    margin: 10,
    fontSize: 30
  },
  textinput4: {
    color: "rgba(0,0,0,1)",
    alignSelf: "stretch",
    textAlign: "left",
    fontWeight: "normal"
  },
  textinput11: {
    color: "rgba(0,0,0,1)",
    alignSelf: "stretch",
    textAlign: "left",
    fontWeight: "normal",
    marginTop: 10
  },
  textinput21: {
    color: "rgba(0,0,0,1)",
    alignSelf: "stretch",
    textAlign: "left",
    fontWeight: "normal",
    marginTop: 10
  },
  textinput31: {
    color: "rgba(0,0,0,1)",
    alignSelf: "stretch",
    textAlign: "left",
    fontWeight: "normal",
    marginTop: 15
  },
  button1: {
    alignSelf: "stretch",
    justifyContent: "center",
    alignItems: "center",
    height: 50,
    flexDirection: "column",
    flexWrap: "nowrap",
    borderRadius: 10,
    backgroundColor: "rgba(255,146,0,1)",
    marginTop: 30
  },
  text11: {
    textAlign: "center",
    flexWrap: "wrap",
    color: "rgba(255,255,255,1)",
    alignSelf: "stretch",
    fontSize: 16,
    fontWeight: "normal"
  }
});


// WEBPACK FOOTER //
// ./src/views/Criarlogin.js